/**
 * Resolve which workspace id property-scoped fetches (detail / assignments / orders) should use.
 *
 * Returns the property's own workspace (from `GET /realty/{propertyId}/workspace`) once the resolver
 * has settled, falling back to the globally selected workspace if the resolver yielded nothing.
 * Returns '' until the resolver settles, so dependent queries stay disabled and don't fire against the
 * (possibly wrong) global workspace first — which would 403 and trip the gallery-redirect guard. See ISSUE-2217.
 *
 * @param isResolved          whether the property-workspace lookup has settled (react-query `isFetched`)
 * @param resolvedWorkspaceId the property's own workspace id, if the lookup returned one
 * @param fallbackWorkspaceId the globally selected workspace id, used when the lookup yielded nothing
 */
export const resolvePropertyWorkspaceId = (
  isResolved: boolean,
  resolvedWorkspaceId?: string | null,
  fallbackWorkspaceId?: string | null
): string => {
  if (!isResolved) return ''

  return resolvedWorkspaceId ?? fallbackWorkspaceId ?? ''
}
